import { Box, Skeleton } from 'vopay';

// Localized loading placeholder rendered in place of a Webhooks table while its data fetches
export default function WebhooksTableSkeleton() {
  return (
    <Box flx="col" gapSize="12px" width="100%" mt="lg">
      <Skeleton height="40px" />
      <Skeleton height="40px" />
      <Skeleton height="40px" />
    </Box>
  );
}
